/**
 * Dropbox share links point at a preview *page*, not the file, so they can't be
 * fed straight into <video> or <img>. Forcing `raw=1` makes Dropbox serve the
 * bytes inline instead (`dl=1` would force a download, which we don't want).
 *
 * Paste the link exactly as Dropbox gives it to you — this normalises it:
 *   https://www.dropbox.com/scl/fi/abc/bungy.mp4?rlkey=xyz&dl=0
 *   → https://www.dropbox.com/scl/fi/abc/bungy.mp4?rlkey=xyz&raw=1
 *
 * Already-direct hosts (dl.dropboxusercontent.com) and local /resources paths
 * are passed through untouched.
 */
export function toDirectMediaUrl(url: string): string {
  return withDropboxFlag(url, "raw");
}

/**
 * Same idea, but for files the browser can't render inline (a .docx resume, a
 * zip). `dl=1` tells Dropbox to send it as an attachment so the browser saves
 * it rather than navigating to a preview page.
 */
export function toDownloadUrl(url: string): string {
  return withDropboxFlag(url, "dl");
}

function withDropboxFlag(url: string, flag: "raw" | "dl"): string {
  if (!url || !url.includes("dropbox.com")) return url;

  const [base, query = ""] = url.split("?");
  const params = new URLSearchParams(query);
  params.delete("dl");
  params.delete("raw");
  params.set(flag, "1");

  return `${base}?${params.toString()}`;
}
